import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom, lastValueFrom, Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { DTO } from 'shared-lib';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  constructor(private http: HttpClient) {}

  async getProfileComplete(id: number | string): Promise<number| null> {
    try {
      return await firstValueFrom(
        this.http.get<number>(`userAccount/profile-complete/${id}`).pipe(
          catchError((error) => {
            console.error(`Erro ao buscar arquivo com ID ${id}:`, error);
            return of(null);
          })
        )
      );
    } catch {
      return null;
    }
  }

}